import type { QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

import { getDashboardIds, getEmbedUrl } from '../api/reporting';
import type { GetDashboardsResponseDTO, GetEmbedUrlResponseDTO } from '../declarations/reporting';

type UseFetchDashboardIdsParamsT = {
  onSuccess: QueryObserverOptions<GetDashboardsResponseDTO, ApiErrorI>['onSuccess'];
  onError: QueryObserverOptions<GetDashboardsResponseDTO, ApiErrorI>['onError'];
};

type UseFetchEmbedUrlParamsT = {
  onSuccess: QueryObserverOptions<GetEmbedUrlResponseDTO, ApiErrorI>['onSuccess'];
  onError: QueryObserverOptions<GetEmbedUrlResponseDTO, ApiErrorI>['onError'];
};

export const useFetchDashboardIds = ({
  onSuccess,
  onError,
}: UseFetchDashboardIdsParamsT): UseQueryResult<GetDashboardsResponseDTO, ApiErrorI> =>
  useQuery<GetDashboardsResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchDashboardIds],
    () => getDashboardIds(),
    {
      onSuccess,
      onError,
    }
  );

export const useFetchEmbedUrl = ({
  dashboardId,
  roofTopIds,
  onSuccess,
  onError,
}: UseFetchEmbedUrlParamsT & { dashboardId: string; roofTopIds: string[] }): UseQueryResult<
  GetEmbedUrlResponseDTO,
  ApiErrorI
> =>
  useQuery<GetEmbedUrlResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchEmbedUrl, dashboardId, roofTopIds],
    () => getEmbedUrl(dashboardId),
    {
      enabled: !!dashboardId,
      onSuccess,
      onError,
    }
  );
